import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { AppointmentsV2Response } from "../schemas/appointment_v2";

export interface GetAppointmentsV2Args {
  userId: number;
  startDate: string;
  view: "day" | "week";
  isAdmin: boolean;
  onlyTherapistAppointments?: boolean;
}

export const getAppointmentsV2QueryKeyPrefix = "getAppointmentsV2";
type QueryKey = [typeof getAppointmentsV2QueryKeyPrefix, GetAppointmentsV2Args];
const getAppointmentsV2QueryKey = (args: GetAppointmentsV2Args): QueryKey => [getAppointmentsV2QueryKeyPrefix, args];

export const useGetAppointmentsV2 = (
  args: GetAppointmentsV2Args,
  options?: UseQueryOptions<AppointmentsV2Response, Error, AppointmentsV2Response, QueryKey>
) => {
  const client = useApiClient();

  const { isAdmin, onlyTherapistAppointments } = args;

  return useQuery({
    queryKey: getAppointmentsV2QueryKey(args),
    queryFn: () => {
      if (isAdmin && !onlyTherapistAppointments) {
        return client.getAppointmentsV2Manager(args);
      }

      return client.getAppointmentsV2(args);
    },
    ...options,
  });
};
